<section class="login-page">

  <!-- Card de formulario flotando sobre el fondo -->
  <article class="login-form-area">
    <div class="login-card">

      <!-- Logo -->
      <div class="card-logo">
        <img src="assets/media/logos/logodef.svg" alt="Defontana" />
      </div>

      <h1>Inicio de sesión</h1>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" [attr.autocomplete]="'off'">

        <div class="field-group">
          <label class="field-label" for="email-input">Dirección de correo electrónico</label>
          <mat-form-field appearance="fill" class="w-100">
            <input id="email-input" matInput placeholder="Correo" formControlName="email" [attr.autocomplete]="'off'"
              [attr.readonly]="true" onfocus="this.removeAttribute('readonly');" type="email">
          </mat-form-field>
        </div>

        <div class="field-group">
          <label class="field-label" for="password-input">Contraseña</label>
          <mat-form-field appearance="fill" class="w-100">
            <input id="password-input" matInput [type]="hide ? 'password' : 'text'" formControlName="password"
              [attr.autocomplete]="'off'" [attr.readonly]="true" onfocus="this.removeAttribute('readonly');"
              placeholder="contraseña">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Mostrar contraseña'"
              [attr.aria-pressed]="hide" type="button">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="form-options-row">
          <label class="remember-label">
            <input type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">
            <span>Recordar datos</span>
          </label>
          <a [routerLink]="'/'+forgotPassword" class="forgot-link">¿Olvidaste tu contraseña?</a>
        </div>

        <small class="privacy-text">
          Al hacer clic en ingresar, aceptas la
          <a href="https://defontana.com/politica-de-privacidad/" target="_blank">Política de Privacidad</a>
          de defontana.com
        </small>

        <button class="btn-confirm" type="submit" [disabled]="form.invalid">Confirmar</button>

        <p class="create-account">
          ¿Eres un nuevo usuario? <a [routerLink]="'/'+registerERP">Crear una cuenta</a>
        </p>

      </form>
    </div>
  </article>

</section>